import { ChartConfiguration } from 'chart.js';
import Chart from 'chart.js/auto';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';
// import { WordCloudChart } from 'chartjs-chart-wordcloud';

import { chartOptions, partyColors } from './constants';
import { BarChartParams } from './types';

Chart.defaults.color = chartOptions.bootstrapBlack;
Chart.defaults.font.size = chartOptions.fontSize;

function generateBarChart(res: any, idSuffix: string, params?: BarChartParams): Chart<any> {
  const chartElem = document.getElementById(`bar-chart${idSuffix}`) as HTMLCanvasElement;
  const type = params.type || 'bar';
  const data = {
    labels: res.labels,
    datasets: [{
      label: `Number of ${params.label}`,
      data: params.isDataPerc ? res.dataPerc : res.data,
      backgroundColor: params.isPartiesChart ? getPartyColors(res.labels) : chartOptions.backgroundColorsSingleHue,
    }],
  };
  let additionalOptions;
  if (!params.verticalBars) {
    additionalOptions = {
      aspectRatio: 1, // This increases the chart height
      indexAxis: 'y' // This makes horizontal bars
    };
  }
  if (type === 'line') {
    additionalOptions = {
      // Show tooltip without going hover the single point
      interaction: {
        intersect: false,
        mode: 'index',
      },
    };
  }
  const chartConfig = {
    type, // bar, line
    data,
    plugins: [
      ...params.plugins || []/* , DataLabelsPlugin */
    ],
    options: {
      borderColor: chartOptions.backgroundColorsSingleHue[0],
      onHover: params.cursorPointer ? chartOptions.onHover : undefined,
      tension: 0.2,
      plugins: {
        legend: { display: false },
        tooltip: params.isDataPerc ?
          chartOptions.tooltipPercentage :
          (params.cursorPointer ? chartOptions.tooltipOpenTwitterOnClick : undefined)
      },
      ...additionalOptions
    },
  } as ChartConfiguration;
  const newChart = new Chart(chartElem, chartConfig);
  return newChart;
}

function generateDonutChart(res: any, idSuffix: string, labelColor?: string): Chart<any> {
  const chartElem = document.getElementById(`donut-chart${idSuffix}`) as HTMLCanvasElement;
  const data = {
    labels: res.labels,
    datasets: [{
      data: res.dataPerc,
      backgroundColor: chartOptions.backgroundColors
    }]
  };
  const chartConfig = {
    type: 'doughnut',
    data,
    plugins: [DataLabelsPlugin],
    options: {
      borderWidth: 0,
      hoverOffset: 5,
      plugins: {
        datalabels: {
          color: labelColor || chartOptions.bootstrapBlack,
          formatter: (value, ctx) => `${value}%`
        },
        legend: { position: 'bottom' },
        tooltip: chartOptions.tooltipPercentage
      }
    },
  } as ChartConfiguration;
  const newChart = new Chart(chartElem, chartConfig);
  return newChart;
}

/* function generateWordCloud(res: any) {
  const chartElem = document.getElementById('word-cloud-chart') as HTMLCanvasElement;
  const data = {
    labels: res.labels,
    datasets: [{ data: res.data }],
  };
  const chartConfig = {
    type: 'wordCloud',
    data,
    options: {
      plugins: {
        legend: { display: false },
      }
    },
  };
  return new WordCloudChart(chartElem, chartConfig);
} */

function getPartyColors(labels: string[]): string[] {
  const colors = [];
  for (const label of labels) {
    if (partyColors[label]) {
      colors.push(partyColors[label]);
    } else {
      colors.push('#000000');
    }
  }
  return colors;
}

function exportChart(chart: any, name: string): void {
  const base64image = chart.toBase64Image();
  const downloadLink = document.createElement('a');
  downloadLink.href = base64image;
  downloadLink.setAttribute('download', `${name}.png`);
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.parentNode.removeChild(downloadLink);
}

export {
  generateBarChart,
  generateDonutChart,
  // generateWordCloud,
  exportChart,
};
